import { useStateChangeTracking } from '@/hooks/useStateChangeTracking';
import { ensureLeadId } from '@/lib/ensureLeadId';
import { FormSortEvent } from '@/types/forms';
import { useCallback } from 'react';

const getStepName = (_stepIndex: number | string | undefined) => {
  if (typeof _stepIndex === 'undefined') return '';

  const stepIndex = _stepIndex.toString();

  const steps: Record<string, string> = {
    '-1': 'Let.s get started.',
    '0': 'First, we.ll need your contact information.',
    '1': 'We.re growing quickly and hope to reach your area soon',
    '3': 'Which of the following have you visited in the past year?',
    '4': 'We.re always at the ready—at any time, day or night—for everything from stitches and prescriptions to labs and imaging.',
    '5': 'How much do you know about concierge healthcare?',
    '6': 'Do you want to sign up additional members?',
    '7': 'What is your date of birth?',
    '8': 'Please enter the details of each additional person you.d like to sign up.',
    '9': 'How did you hear about Sollis?',
    '10': 'What matters most to you in a healthcare experience?',
  };

  return steps[stepIndex] ? steps[stepIndex] : '';
};

export const useIntakeFormStepTracking = () => {
  const { track, loading, error } = useStateChangeTracking();

  const trackStep = useCallback(
    async (data: FormSortEvent) => {
      const {
        contact_details,
        visited_locations,
        healthcare_priorities,
        concierge_healthcare_familiarity,
        number_of_members,
        additional_members,
        members,
        reference,
        date_of_birth,
      } = data.answers || {};

      const memberInfo = additional_members
        ? { number_of_members, members }
        : undefined;

      const trackingData = {
        ...(contact_details ? { ...contact_details } : {}),
        ...(visited_locations ? { visited_locations } : {}),
        ...(healthcare_priorities ? { healthcare_priorities } : {}),
        ...(concierge_healthcare_familiarity
          ? { concierge_healthcare_familiarity }
          : {}),
        ...memberInfo,
        reference,
        date_of_birth,
      };

      const leadId = await ensureLeadId();

      track({
        source: 'intake_v1',
        stateInformation: {
          stepId: data.stepId,
          stepIndex: data.stepIndex,
          stepName: getStepName(data.stepIndex),
        },
        payload: { ...trackingData, leadId },
      });
    },
    [track]
  );

  return { trackStep, loading, error };
};
